import { useContext, useMemo } from 'react';
import { PropertyContext } from './PropertyContext';
import { HighlySensitivePropertyContext } from '../../../dataSensitivity/HighlySensitivePropertyContext';
import { PropertyDataSensitivity } from 'customer-data-objects/property/PropertyDataSensitivity';
import { AIPropertiesProcessingContext } from '../../../ai/AIPropertiesProcessingContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropertyContextProvider = props => {
  const {
    accessLevelOverride,
    objectTypeId,
    objectId,
    property,
    value,
    autoManageHighlySensitiveValue,
    timestamp,
    getAdditionalPropertyValue,
    LoadingValueComponent
  } = props;
  const highlySensitivePropertyContext = useContext(HighlySensitivePropertyContext);
  const aiProcessingContext = useContext(AIPropertiesProcessingContext);
  const propertyContextValue = useMemo(() => {
    let finalValue = value;

    // Allows internal management of the value for highly sensitive properties
    // so that the consumer doesn't need to manage decrypted value state themselves.
    if (autoManageHighlySensitiveValue && property.dataSensitivity === PropertyDataSensitivity.HIGH) {
      if (!highlySensitivePropertyContext) {
        throw new Error('Cannot use autoManageHighlySensitiveValue without highlySensitivePropertyContext');
      }
      if (objectId) {
        const highlySensitivePropertyValue = highlySensitivePropertyContext.getHighlySensitivePropertyValue({
          objectTypeId,
          objectId,
          propertyName: property.name,
          timestamp
        });
        if ((highlySensitivePropertyValue === null || highlySensitivePropertyValue === void 0 ? void 0 : highlySensitivePropertyValue.status) === 'SUCCEEDED') {
          finalValue = highlySensitivePropertyValue.value;
        }
      }
    } else if (aiProcessingContext) {
      if (objectId) {
        finalValue = aiProcessingContext.applyLoadedValue(objectTypeId, property.name, objectId, value);
      }
    }
    return {
      accessLevelOverride,
      objectTypeId,
      objectId,
      property,
      timestamp,
      value: finalValue,
      getAdditionalPropertyValue,
      LoadingValueComponent
    };
  }, [accessLevelOverride, aiProcessingContext, autoManageHighlySensitiveValue, getAdditionalPropertyValue, highlySensitivePropertyContext, LoadingValueComponent, objectId, objectTypeId, property, timestamp, value]);
  return /*#__PURE__*/_jsx(PropertyContext.Provider, {
    value: propertyContextValue,
    children: props.children
  });
};